import React, { useState, useEffect } from "react";
import Box from "@mui/joy/Box";
import Sheet from "@mui/joy/Sheet";
import Typography from "@mui/joy/Typography";
import Button from "@mui/joy/Button";

interface CountdownTimerProps {
  onComplete: () => void;
  isActive: boolean;
}

const CountdownTimer: React.FC<CountdownTimerProps> = ({
  onComplete,
  isActive,
}) => {
  const [count, setCount] = useState<number>(3);

  useEffect(() => {
    if (!isActive || isActive) {
      setCount(3);
    }
  }, [isActive]);

  useEffect(() => {
    let timer: ReturnType<typeof setTimeout>;
    if (isActive && count > 0) {
      timer = setTimeout(() => {
        setCount(count - 1);
      }, 1000);
    } else if (isActive && count === 0) {
      onComplete();
      setCount(3);
    }

    return () => {
      clearTimeout(timer);
    };
  }, [count, isActive, onComplete]);

  const handleSkip = () => {
    onComplete();
    setCount(3);
  };

  if (!isActive) return null;

  return (
    <Box
      sx={{
        position: "fixed",
        inset: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 20,
      }}
    >
      <Box
        sx={{
          position: "relative",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Sheet
          variant="soft"
          sx={{
            width: 200,
            height: 200,
            borderRadius: "50%",
            bgcolor: "rgba(46, 45, 126, 0.9)",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography
            level="h1"
            sx={{ color: "#fff", fontWeight: "700", fontSize: "6rem" }}
          >
            {count}
          </Typography>
          <Typography
            level="body-md"
            sx={{
              color: "#fff",
              fontSize: "1.2rem",
              fontWeight: "500",
              cursor: "pointer",
            }}
            onClick={handleSkip}
          >
            Skip
          </Typography>
        </Sheet>
      </Box>
    </Box>
  );
};

export default CountdownTimer;
